import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, Typography, Button, TextField, Collapse, Select, MenuItem } from '@mui/material';
import AmountSummaryReport from './AmountSummaryReport';
import ExpenseSummaryReport from './ExpenseSummaryReport';
import WeightSummaryReport from './WeightSummaryReport';
import MoneyExchangeSummaryReport from './MoneyExchangeSummaryReport';
import ProfitSummaryReport from './ProfitSummaryReport';
import NewCustomerReport from './NewCustomerReport';
import RegisMonthSummaryReport from './regisMonthAmount/RegisMonthAmountReport';
import ReceiptAmountSummaryReport from './ReceiptAmountSummaryReport';
import MonthlyProfitReport from './monthlyProfit/MonthlyProfitReport';
import PendingPaymentDetailsReport from './PendingPaymentDetailsReport';
import CompanyCustomerSummaryReport from './CompanyCustomerSummaryReport';
import CustomerProfitSummaryReport from './CustomerProfitSummaryReport';
import OrderRoutingReport from './OrderRoutingReport';
import TranslationUsageReport from './TranslationUsageReport';
import PlatformCustomerReport from './platformCustomer/PlatformCustomerReport';
import DispatchReport from '../mercari/dispatchReport/DispatchReport';

const indigoStyle = {
  backgroundColor: '#5C6BC0', // Tailwind's indigo-600
  color: '#fff'
};

function currentDate() {
  let d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

const ReportSelectionPage = () => {
  const navigate = useNavigate();
  const [reportDate, setReportDate] = useState({ startDate: currentDate(), endDate: currentDate() });
  const [showReportSelection, setShowReportSelection] = useState(true);
  const [groupBy, setGroupBy] = useState('month'); // 'date' or 'month'
  const [selectedReport, setSelectedReport] = useState('')
  const [haveDate, setHaveDate] = useState(false)
  const [reportName, setReportName] = useState('')

  const reportList = [
    {
      text : 'Amount Summary',
      name : 'amountSummary',
      haveDate : true
    },
    {
      text : 'Expense Summary',
      name : 'expenseSummary',
      haveDate : false
    },{
      text : 'Weight Summary',
      name : 'weightSummary',
      haveDate : false
    },{
      text : 'Exchange Money Summary',
      name : 'moneyExchangeSummary',
      haveDate : false
    },{
      text : 'Profit Summary',
      name : 'profitSummary',
      haveDate : false
    },{
      text : 'Register Month Amount Summary',
      name : 'registerMonthAmountSummary',
      haveDate : false
    },{
      text : 'Receipt Amount Summary',
      name : 'receiptAmountSummary',
      haveDate : false
    },{
      text : 'New Customer Performance Summary',
      name : 'newCustomerSummary',
      haveDate : false
    },{
      text: 'Monthly Profit Analysis',
      name: 'monthlyProfit',
      haveDate: false
    },{
      text: 'Customer Pending Payment Details',
      name: 'pendingPaymentDetails',
      haveDate: false
    },{
      text: 'Company Customer Summary',
      name: 'companyCustomerSummary',
      haveDate: false
    },    {
      text: 'Customer Profit Summary',
      name: 'customerProfitSummary',
      haveDate: false
    },
    {
      text: 'Order Routing Analysis',
      name: 'orderRoutingAnalysis',
      haveDate: false
    },
    {
      text: 'Translation Usage',
      name: 'translationUsage',
      haveDate: false
    },
    {
      text: 'Platform Customers',
      name: 'platformCustomers',
      haveDate: false
    },
    {
      text: 'สรุปคนกด Mercari',
      name: 'mercariBuyerReport',
      haveDate: false
    }
  ]

  const renderReportComponent = () => {
    switch (selectedReport) {
      case 'amountSummary': 
        return <AmountSummaryReport startDate={reportDate.startDate} endDate={reportDate.endDate} groupBy={groupBy}/>;
      case 'expenseSummary':
        return <ExpenseSummaryReport/>;
      case 'weightSummary':
        return <WeightSummaryReport/>;
      case 'moneyExchangeSummary':
        return <MoneyExchangeSummaryReport/>;
      case 'profitSummary':
        return <ProfitSummaryReport/>;
      case 'newCustomerSummary':
        return <NewCustomerReport/>;
      case 'registerMonthAmountSummary':
        return <RegisMonthSummaryReport/>;
      case 'receiptAmountSummary':
        return <ReceiptAmountSummaryReport/>;
      case 'monthlyProfit':
        return <MonthlyProfitReport/>;
      case 'pendingPaymentDetails':
        return <PendingPaymentDetailsReport startDate={reportDate.startDate} endDate={reportDate.endDate} groupBy={groupBy}/>;
      case 'companyCustomerSummary':
        return <CompanyCustomerSummaryReport/>;
      case 'customerProfitSummary':
        return <CustomerProfitSummaryReport/>;
      case 'orderRoutingAnalysis':
        return <OrderRoutingReport />;
      case 'translationUsage':
        return <TranslationUsageReport />;
      case 'platformCustomers':
        return <PlatformCustomerReport />;
      case 'mercariBuyerReport':
        return <DispatchReport />;
      default:
        return null;
    }
  };

  const handleReportSelection = (report, groupBy) => {
    setShowReportSelection(false);
    setGroupBy(groupBy)
    setSelectedReport(report)
  };

  const toggleReportSelection = () => {
    if(!showReportSelection){
      setSelectedReport(null)
    }
    setShowReportSelection(!showReportSelection);
  };

  useEffect(() => {
    const foundReport = reportList.find(report => report.name === selectedReport);
    setHaveDate(foundReport?.haveDate)
    setReportName(foundReport?.text)
  },[selectedReport])

  return (
    <div className="flex flex-col items-center gap-4 m-4">
      <Collapse in={showReportSelection}>
        <div className="flex flex-wrap justify-center gap-4">
          <Card style={{ backgroundColor: '#2e7d32' }} className="w-60">
            <CardContent>
              <Typography gutterBottom variant="h5" component="div" style={{ color: '#fff' }}>
                Dividend Dashboard
              </Typography>
              <div className="flex flex-col gap-2">
                <Button onClick={() => navigate('/report/dividend')} variant="contained" style={{ backgroundColor: '#FFF', color: '#2e7d32' }}>Open Dashboard</Button>
              </div>
            </CardContent>
          </Card>

          {reportList.map((report, index) => (
            <Card key={index} style={indigoStyle} className="w-60">
              <CardContent>
                <Typography gutterBottom variant="h5" component="div" style={{ color: indigoStyle.color }}>
                  {report.text}
                </Typography>
                <div className="flex flex-col gap-2">
                  {report.haveDate ? (
                    <>
                      <Button onClick={() => handleReportSelection(report.name, 'month')} variant="contained" style={{ backgroundColor: '#FFF', color: indigoStyle.backgroundColor }}>Monthly Summary</Button>
                      <Button onClick={() => handleReportSelection(report.name, 'date')} variant="contained" style={{ backgroundColor: '#FFF', color: indigoStyle.backgroundColor }}>Date Summary</Button>
                    </>
                  ) : (
                    <Button onClick={() => handleReportSelection(report.name, 'month')} variant="contained" style={{ backgroundColor: '#FFF', color: indigoStyle.backgroundColor}}>Open Report</Button>
                  )}
                  </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </Collapse>

      {!showReportSelection && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Button onClick={toggleReportSelection} style={{ color: indigoStyle.backgroundColor, marginRight: 'auto' }}>
            Back to Report Selection
          </Button>
          {haveDate && <>
              <Select value={groupBy} onChange={(e) => setGroupBy(e.target.value)} style={{ flexGrow: 1 }}>
                <MenuItem value="date">Date</MenuItem>
                <MenuItem value="month">Month</MenuItem>
              </Select>
              {groupBy === 'date' && (
                <>
                  <TextField
                    label="Start Date"
                    type="date"
                    value={reportDate.startDate}
                    onChange={(e) => setReportDate({ ...reportDate, startDate: e.target.value })}
                    InputLabelProps={{ shrink: true }}
                    style={{ width: '200px' }}
                  />
                  <TextField
                    label="End Date"
                    type="date"
                    value={reportDate.endDate}
                    onChange={(e) => setReportDate({ ...reportDate, endDate: e.target.value })}
                    InputLabelProps={{ shrink: true }}
                    style={{ width: '200px' }}
                  />
                </>
              )}
            </>
          }
        </div>
      )}
      {!showReportSelection &&  <h3 className='text-4xl mr-auto'>{`${reportName} Report`}</h3>}
      {renderReportComponent()}
    </div>
  );
};

export default ReportSelectionPage;
